import PropTypes from 'prop-types';

const KeyFeatures = ({ translate }) => (
    <div className="key-features">
      <img className="preview-img" src={`${process.env.PUBLIC_URL}/images/timeline-example.jpg`} alt="preview" />
      <table className="key-features-table">
        <tbody>
          <tr>
            <td className="label-cell">- {translate('freeAccount')}:</td>
            <td>{translate('noCreditCartRequired')}</td>
          </tr>
          <tr>
            <td className="label-cell">- {translate('interactiveTimeline')}:</td>
            <td>{translate('schedulingWithVisualRepresentation')}</td>
          </tr>
          <tr>
            <td className="label-cell">- {translate('paymentStatuses')}:</td>
            <td>{translate('filterOrdersByPaymentStatus')}</td>
          </tr>
          <tr>
            <td className="label-cell">- {translate('quickSearch')}:</td>
            <td>{translate('findReservationsByDateAndStatus')}</td>
          </tr>
          <tr>
            <td className="label-cell">- {translate('employeeAccounts')}:</td>
            <td>{translate('secureLoginAndRoleAccess')}</td>
          </tr>
          <tr>
            <td className="label-cell">- {translate('mobileResponsive')}:</td>
            <td>{translate('fullyResponsiveUiForBooking')}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )

  KeyFeatures.propTypes = {
    translate: PropTypes.func.isRequired
  };
  
export default KeyFeatures;
